$mol_example $mol_view
	tags /string
	aspects /string
